// extracted by mini-css-extract-plugin
export default {"layout":"LKkD8rum","loaderContainer":"wWbUcIXG"};